import React from "react";
import { Wrapper, Image } from "./styled";
import Icon from "../../../../images/goToBackBlue.svg";

const GoToBackIcon = () => {
  return (
    <Wrapper>
      <Image src={Icon} alt="icon" />
    </Wrapper>
  );
};

export default GoToBackIcon;
